/* eslint-disable no-underscore-dangle */
import { Grid } from '@elliemae/ds-grid';
import { kfrm, styled } from '@elliemae/ds-system';
import { DSCircularIndeterminateIndicatorName, DSCircularIndeterminateIndicatorSlots } from './constants.js';
const { PI } = Math;

const getArcLength = (percentage: number, radius: number) => ((2 * PI * radius) / 100) * percentage;

const svgRotateAnimation = kfrm`
    0% {
        transform: rotate(0);
    }
    100% {
        transform: rotate(360deg);
    }
`;

const strokeTailAnimation = (r: number) => {
  const miniDash = `${getArcLength(0, r)} ${getArcLength(100, r)}`;
  const fullDash = `${getArcLength(75, r)} ${getArcLength(25, r)}`;

  return kfrm`
    0% {
        stroke-dasharray: ${miniDash};
    }
    50% {
        stroke-dasharray: ${fullDash};
    }
    100% {
        stroke-dasharray: ${miniDash};
    }
`;
};

const rotateAnimation = kfrm`
    0%, 12.5% {
        transform: rotate(0);
    }
    25%, 37.5% {
        transform: rotate(270deg);
    }
    50%, 62.5% {
        transform: rotate(540deg);
    }
    75%, 87.5% {
        transform: rotate(810deg);
    }
    100% {
        transform: rotate(1080deg);
    }
`;

const dashAnimation = (r: number) => {
  const miniDash = `${getArcLength(0, r)} ${getArcLength(100, r)}`;
  const fullDash = `${getArcLength(75, r)} ${getArcLength(25, r)}`;

  return kfrm`
    0% {
        stroke-dasharray: ${miniDash};
        stroke-dashoffset: 0;
    }
    12.5% {
        stroke-dasharray: ${fullDash};
        stroke-dashoffset: 0;
    }
    25% {
        stroke-dasharray: ${miniDash};
        stroke-dashoffset: ${getArcLength(-75, r)};
    }
    37.5% {
        stroke-dasharray: ${fullDash};
        stroke-dashoffset: ${getArcLength(-75, r)};
    }
    50% {
        stroke-dasharray: ${miniDash};
        stroke-dashoffset: ${getArcLength(-150, r)};
    }
    62.5% {
        stroke-dasharray: ${fullDash};
        stroke-dashoffset: ${getArcLength(-150, r)};
    }
    75% {
        stroke-dasharray: ${miniDash};
        stroke-dashoffset: ${getArcLength(-225, r)};
    }
    87.5% {
        stroke-dasharray: ${fullDash};
        stroke-dashoffset: ${getArcLength(-225, r)};
    }
    100% {
        stroke-dasharray: ${miniDash};
        stroke-dashoffset: ${getArcLength(-300, r)};
    }
`;
};

export const StyledContainer = styled(Grid, {
  name: DSCircularIndeterminateIndicatorName,
  slot: DSCircularIndeterminateIndicatorSlots.ROOT,
})<{ inline: boolean }>`
  ${({ inline, theme }) => (!inline ? `z-index: ${theme.zIndex.loader}` : ``)}
`;

export const StyledSvg = styled('svg', {
  name: DSCircularIndeterminateIndicatorName,
  slot: DSCircularIndeterminateIndicatorSlots.SVG,
})`
  display: block;
  margin: auto;
  transform-origin: center center;
  transform: rotate(-90deg);
  animation: ${svgRotateAnimation} 2.5s linear infinite;
`;

export const StyledPath = styled.path<{ r: number }>`
  transform-origin: center center;
  animation:
    ${rotateAnimation} 10s linear infinite,
    ${(props) => strokeTailAnimation(props.r)} 2.5s linear infinite;
`;

export const StyledRect = styled.rect`
  transform-origin: center center;
  animation: ${rotateAnimation} 10s linear infinite;
`;

export const StyledCircle = styled.circle<{ r: number }>`
  stroke-dashoffset: 0;
  fill: none;
  animation: ${(props) => dashAnimation(props.r)} 10s linear infinite;
  clip-path: ${(props) => props.clipPath};
  -webkit-clip-path: ${(props) => props.clipPath};
`;

export const StyledLabel = styled('span', {
  name: DSCircularIndeterminateIndicatorName,
  slot: DSCircularIndeterminateIndicatorSlots.LABEL,
})``;
